import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a516cca2cc2500014f830b6_1789423774101_36b4f000/mbgnexus/src/app/sign-up-login-screen/components/AuthScreen.tsx");
